// Dismissible modal ad.
// Shows once per browsing session after a short delay, and remembers an
// explicit dismissal for N days (localStorage). All storage access is guarded
// so private-mode / blocked storage degrades gracefully. Uses Bootstrap Modal.
/* eslint-disable no-param-reassign, no-self-assign */
import Modal from 'bootstrap/js/dist/modal';

(() => {
  const DISMISS_KEY = 'muModalAdDismissedUntil';
  const SESSION_KEY = 'muModalAdShown';

  document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('mu-modal-ad');
    if (!el) return;

    // Respect an explicit dismissal window.
    try {
      const until = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
      if (until && Date.now() < until) return;
    } catch (e) { /* storage blocked — continue */ }

    // Only once per browsing session.
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
    } catch (e) { /* ignore */ }

    const delay = parseInt(el.dataset.muDelay || '2500', 10);
    const days = parseFloat(el.dataset.muFrequencyDays || '1');
    const modal = new Modal(el, { backdrop: true, keyboard: true });

    el.addEventListener('hidden.bs.modal', () => {
      const ms = Math.max(0, days) * 24 * 60 * 60 * 1000;
      try { localStorage.setItem(DISMISS_KEY, String(Date.now() + ms)); } catch (e) { /* ignore */ }
      // Stop any playing embedded video by resetting its src.
      el.querySelectorAll('iframe, video').forEach((m) => { m.src = m.src; });
    });

    window.setTimeout(() => {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* ignore */ }
      modal.show();
    }, Math.max(0, delay));
  });
})();
